import { Button } from "@/components/ui/button";
import { CalendarCheck, ArrowRight, Sparkles } from "lucide-react";
import { addOns } from "@/config/stripePlans";

// Upgrade gate shown when a business without the Dibs Bookings add-on tries to
// reach the bookings workspace / storefront directly (the sidebar hides it, but
// a deep link would otherwise render the workspace). Routes to Billing & plan.
const BookingsAddonGate = ({ onUpgrade }: { onUpgrade: () => void }) => {
  const price = addOns.bookings?.price.monthly ?? 20;
  return (
    <div className="mx-auto flex max-w-lg flex-col items-center gap-5 rounded-2xl border border-border bg-card p-8 text-center shadow-sm">
      <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10">
        <CalendarCheck className="h-7 w-7 text-primary" />
      </span>
      <div className="space-y-2">
        <h2 className="text-xl font-heading font-semibold text-foreground">
          Unlock Dibs Bookings
        </h2>
        <p className="text-sm text-muted-foreground">
          The bookings workspace, storefront, listings, and waitlist are part of
          the Dibs Bookings add-on (S${price}/mo). Add it to your plan to start
          taking bookings.
        </p>
      </div>
      <Button size="lg" onClick={onUpgrade}>
        <Sparkles className="h-4 w-4" />
        See plans &amp; add Dibs Bookings
        <ArrowRight className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default BookingsAddonGate;
